import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      if (!match) {
        navigate('/login', { replace: true });
        return;
      }
      const sessionId = match[1];

      try {
        const { data } = await axios.post(
          `${API_URL}/api/auth/google/session`,
          { session_id: sessionId }
        );
        // Store JWT in localStorage so cross-domain Bearer auth works
        if (data?.access_token) {
          localStorage.setItem('aptivon_token', data.access_token);
        }
        // Refresh user data in AuthContext
        await refreshUser();
        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Google auth failed:', err);
        navigate('/login', { replace: true });
      }
    };

    processCallback();
  }, [navigate, refreshUser]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-[#0EA5E9]"></div>
        <p className="mt-4 text-[#6B7280]">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
